import * as Types from '../constants/Types';

export const getListAirports = (filters) => ({ type: Types.AIRPORT_LIST_ACTION, filters });
export const setListAirports = (airports) => ({ type: Types.AIRPORT_LIST_SUCCESS, airports});

export const getAirportDetail = (id) => ({ type: Types.AIRPORT_DETAIL_ACTION, id })
export const setAirportDetail = (airport) => ({ type: Types.AIRPORT_DETAIL_SUCCESS, airport });

export const updateAirportDetail = (airport) => ({ type: Types.AIRPORT_DETAIL_UPDATE_ACTION, airport });
export const createAirportDetail = (airport) => ({ type: Types.AIRPORT_DETAIL_CREATE_ACTION, airport });
export const deleteAirportDetail = (airport, filters) => ({ type: Types.AIRPORT_DETAIL_DELETE_ACTION, airport, filters });

export const createAirportTranslate = (airport) => ({type: Types.AIRPORT_CREATE_TRANSLATE_ACTION, airport});
export const updateAirportTranslate = (airport) => ({type: Types.AIRPORT_UPDATE_TRANSLATE_ACTION, airport});
export const deleteAirportTranslate = (airport, refreshParams) => ({type: Types.AIRPORT_DELETE_TRANSLATE_ACTION, airport, refreshParams});

export const getListAirlineDomestic = () => ({type: Types.AIRLINE_LIST_DOMESTIC_ACTION});
export const setListAirlineDomestic = (airlines) => ({type: Types.AIRLINE_LIST_DOMESTIC_SUCCESS, airlines});

export const getListAirportDeparture = () => ({type: Types.AIRPORT_LIST_DEPARTURE_ACTION});
export const setListAirportDeparture = (airportsDeparture) => ({type: Types.AIRPORT_LIST_DEPARTURE_SUCCESS, airportsDeparture});

export const getListAirportArrival = () => ({type: Types.AIRPORT_LIST_ARRIVAL_ACTION});
export const setListAirportArrival = (airportsArrival) => ({type: Types.AIRPORT_LIST_ARRIVAL_SUCCESS, airportsArrival});
export const getToAirportList = (id) => ({ type: Types.TOAIRPORT_LIST_ACTION, id })
export const setToAirportList = (airports) => ({ type: Types.TOAIRPORT_LIST_SUCCESS, airports });
export const createToAirportList = (id, airportCodes) => ({type: Types.TOAIRPORT_LIST_CREATE_ACTION, id, airportCodes});
export const updateToAirportList = (id, airportCodes) => ({type: Types.TOAIRPORT_LIST_UPDATE_ACTION, id, airportCodes});

export const getAirlineSourceVJ = () => ({type: Types.AIRLINE_SOURCE_GET});
export const setAirlineSourceVJ = (airlineSourceVJ) => ({ type: Types.AIRLINE_SOURCE_SET, airlineSourceVJ});
export const updateAirlineSource = (params) => ({type: Types.AIRLINE_SOURCE_UPDATE, params});